/**
 * The messages cycled while a reply that started before this page load finishes. They tell the user
 * the session is being picked back up rather than that nothing is happening.
 */
export function getReconnectingLoadingTexts(): string[] {
  return [
    window.i18next.t('pmwjs_ai_chat_reconnecting_to_session'),
    window.i18next.t('pmwjs_ai_chat_still_working_on_it'),
    window.i18next.t('pmwjs_ai_chat_finishing_up'),
    window.i18next.t('pmwjs_ai_chat_almost_ready'),
  ];
}
